module.exports = __webpack_public_path__ + "img/insta.5ab46ab6.svg";